module.exports = __webpack_public_path__ + "static/lsreactang-9553405da5a393994a59db4d0c7c1b0e.png";